import { Injectable } from '@angular/core';

const KEY_PREFIX = 'formops:draft-key:';

@Injectable({ providedIn: 'root' })
export class FormDraftKeyStorageService {
  getOrCreate(workspaceSlug: string, formSlug: string): string {
    const key = this.storageKey(workspaceSlug, formSlug);
    const existing = localStorage.getItem(key)?.trim();
    if (existing) {
      return existing;
    }
    const minted =
      typeof crypto !== 'undefined' && 'randomUUID' in crypto
        ? crypto.randomUUID()
        : `draft_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem(key, minted);
    return minted;
  }

  rotate(workspaceSlug: string, formSlug: string): string {
    const key = this.storageKey(workspaceSlug, formSlug);
    localStorage.removeItem(key);
    return this.getOrCreate(workspaceSlug, formSlug);
  }

  private storageKey(workspaceSlug: string, formSlug: string): string {
    return `${KEY_PREFIX}${workspaceSlug.trim().toLowerCase()}:${formSlug.trim().toLowerCase()}`;
  }
}
